/* eslint-disable react/jsx-pascal-case */
import React from "react";
import {
  MaterialReactTable,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
  useMaterialReactTable,
} from "material-react-table";
import Skeleton from "react-loading-skeleton";

import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";

import Button from "@atlaskit/button";
import RefreshIcon from "@atlaskit/icon/glyph/refresh";

import styles from "./MaterialTable.module.css";
import { BsTable } from "react-icons/bs";
import FilterIcon from "@atlaskit/icon/glyph/filter";

const HomeTable = ({
  tableData,
  columns,
  data,
  appType,
  resetFilters,
  isLoading,
  isError,
  isRefetching,
  setRefresh,
  rowCount,
  onPaginationChange,
  setShowDownloadConfirm,
  columnFilters,
  setColumnFilters,
  pagination,
  setPagination,
  tableTitle,
}) => {
  const table = useMaterialReactTable({
    columns,
    data,
    positionGlobalFilter: "left",
    enableFullScreenToggle: true,
    enableColumnOrdering: true,
    manualFiltering: true,
    enableGlobalFilter: false,
    enableColumnFilters: true,
    layoutMode: "grid",
    // initital state
    initialState: {
      pagination: { pageSize: 50, pageIndex: 0 },
      density: "compact",
      showColumnFilters: true,
      // columnFilters: [],
    },
    // enableBottomToolbar: rowCount !== 0,
    enableBottomToolbar: true,
    manualPagination: true,
    enablePagination: false,
    muiPaginationProps: {
      showFirstButton: true,
      showLastButton: true,
    },
    enableSorting: true,
    // onSortingChange: setSorting,
    enableStickyHeader: true,
    enableTopToolbar: true,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    onColumnFiltersChange: setColumnFilters,
    renderEmptyRowsFallback: () => (
      <strong className={styles.renderEmptyRowsFallback}>No data found</strong>
    ),
    renderToolbarInternalActions: () => {
      return (
        <div className={styles.renderToolbarInternalActions}>
          <Button
            appearance="default"
            type="submit"
            onClick={resetFilters}
            iconBefore={<FilterIcon size="small" />}
          >
            Reset
          </Button>
          <Button
            appearance="subtle"
            onClick={() => setRefresh((prev) => !prev)}
            iconBefore={<RefreshIcon size="medium" />}
          />
          <MRT_ToggleFiltersButton table={table} />
          <MRT_ShowHideColumnsButton table={table} />
          <MRT_ToggleFullScreenButton table={table} />
        </div>
      );
    },
    renderTopToolbarCustomActions: () => {
      return (
        <h4 className={styles.tableCaption}>
          <BsTable />
          {tableTitle}
        </h4>
      );
    },
    renderBottomToolbar: () => (
      <div className={styles.tableFooterContainer}>
        <div className={styles.tableCount}>
          Total:&nbsp;
          {isLoading ? <Skeleton width={"20px"} /> : rowCount}
        </div>
        <div className={styles.pageActions}></div>
        <div className={styles.paginationContainer}>
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(rowCount / pagination.pageSize)}
              shape="rounded"
              size="medium"
              boundaryCount={1}
              siblingCount={1}
              onChange={onPaginationChange}
              disabled={isLoading || isRefetching}
              page={pagination.pageNumber}
            />
          </Stack>
        </div>
      </div>
    ),
    state: {
      isLoading,
      showProgressBars: isRefetching,
      showSkeletons: isLoading || isRefetching,
      density: "compact",
      isRefetching,
      columnFilters: columnFilters,
      sorting: [
        {
          id: "id",
          desc: true,
        },
      ],
    },
    muiTopToolbarProps: {
      elevation: 0,
      sx: {
        borderRadius: "0",
      },
    },
    muiBottomToolbarProps: {
      elevation: 10,
      sx: {
        borderRadius: "0",
        marginRight: "-.5rem",
      },
    },
    muiTableHeadCellProps: {
      sx: {
        fontWeight: "bold",
        "& .MuiTableSortLabel-root": {
          cursor: "text",
        },
        "& .Mui-TableHeadCell-Content-Labels": {
          cursor: "text",
        },
      },
    },
    muiTablePaperProps: ({ table }) => ({
      elevation: 0, //change the mui box shadow
      sx: {
        borderRadius: "0",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      style: {
        zIndex: table.getState().isFullScreen ? 1000 : undefined,
        position: table.getState().isFullScreen ? "fixed" : "static",
        top: table.getState().isFullScreen ? "66px" : "0px",
        padding: table.getState().isFullScreen ? "0 1rem" : "0px",
        height: "100%",
      },
    }),
    muiTableContainerProps: ({ table }) => ({
      elevation: 0, //change the mui box shadow
      sx: {
        borderTop: "1px solid var(--greyline)",
      },
      style: {
        width: "100%",
        height: table.getState().isFullScreen
          ? "calc(100vh - 178px)"
          : "calc(100vh - 296px)",
      },
    }),
    muiToolbarAlertBannerProps: isError
      ? {
          color: "error",
          children: "Error loading data",
        }
      : undefined,
  });

  return (
    <div className={styles.tableContainer}>
      <MaterialReactTable table={table} />
    </div>
  );
};

export default HomeTable;
